// extracted by mini-css-extract-plugin
export default {"root":"WorkInProgressCover_root__Pqb+k","content":"WorkInProgressCover_content__Spc70","overlay":"WorkInProgressCover_overlay__5kh1Z","label":"WorkInProgressCover_label__UDkMM"};